module.exports = __webpack_public_path__ + "img/maple-leaf.74e428a4.svg";